<template>
  <SidebarTemplate
    :sidebar="sidebar"
    :loading="loading"
    :uuid="uuid"
    class="sidebar--vueberg"
  >
    <div class="vueberg-content pe-1 ps-2" v-html="content"></div>
  </SidebarTemplate>
</template>

<script>
import { mapActions } from 'vuex';
import SidebarTemplate from '@/components/sidebar/SidebarTemplate.vue';
export default {
  name: 'VuebergInfo',
  components: {
    SidebarTemplate,
  },
  props: {
    sidebar: {
      type: Object,
      required: true,
    },
    uuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      content: null,
      loading: true,
      abortController: null,
    };
  },
  watch: {
    uuid: {
      handler() {
        if (this.abortController) {
          this.abortController.abort(); // Отмена предыдущего запроса
        }
        this.abortController = new AbortController();

        this.loadContent(this.abortController.signal);
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['axiosWrapped']),
    async loadContent(signal) {
      try {
        const response = await this.axiosWrapped({
          url: `public/vueberg-contents/${this.sidebar.context}`,
          signal,
        });
        this.content = response.data.data;
        this.loading = false;
      } catch (error) {
        if (error.name !== 'CanceledError') {
          console.error(error);
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped></style>
